import { OfferStatusHistoryModel } from './offerStatusHistoryModel';
import { ClientDataModel } from '../offerSteps/clientDataModel';
import { TwoDimPlanModel } from '../offerSteps/twoDimPlanModel';
import { GasInstallationModel } from '../offerSteps/gasInstallationModel';
import { HeathInstallModel } from '../offerSteps/heathInstallModel';
import { FileModel } from '../fileModel';
import { UserModel } from '../user/userModel';

export class OfferStepModel {
    public id: number;
    public offerStatusId: number;
    public clientData: ClientDataModel;
    public trader: UserModel;
    public twoDimPlan: TwoDimPlanModel;
    public planner: any;
    public offerNumber: string;
    public offerDate: string;
    public gasInstallation: GasInstallationModel;
    public heathInstall: HeathInstallModel;
    public activeStep: number;
    public completed: Array<number>;
    public heathInstallCheck: boolean;
    public workAndMaterials: boolean;
    public disclaimer: string;
    public gasInstallSvg: string;
    public heathInstallSvg: string;
    public price: number;
    public installationPdf: FileModel;
    public billOfQuantitiesExcel: FileModel;
    public billOfQuantitiesLaborExcel: FileModel;
    public offerPdf: FileModel;
    public discount: number;
    public fixedDiscount: number;
    public reported: boolean;
    public updatedOn: string;
    public priceChanged: boolean;
    public statusHistory: Array<OfferStatusHistoryModel>;
    public adminNotes: string;
    public equipmentOnly: boolean;
    //public imgSrc: any;
}